module.exports = __webpack_public_path__ + "resources/avatar_loading.f3b7f1dd179cc2a7.png";